if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.disableSelectedVariantDefault = this.mainProduct.dataset.disableSelectedVariantDefault === "true" || false;
        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.init();
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }

        this.variantData = this.getVariantData();

        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty("--m-translate-y", 0);
                } else {
                  this.container.style.setProperty("--m-translate-y", "100%");
                }
                document.documentElement.classList[entry.intersectionRatio !== 1 ? "add" : "remove"]("stick-atc-show");
                this.scheduleFloatingSync();
              });
            },
            { threshold: 1, rootMargin }
          );
        }

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;
        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        this.handleCustomFields();

        this.setObserveTarget();
        this.syncWithMainProductForm();

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        mql.onchange = this.setStickyAddToCartHeight.bind(this);
        this.setStickyAddToCartHeight();

        // GATORHATS: xep lai cac nut noi o goc phai duoi
        this.scheduleFloatingSync();
        this.container.addEventListener("transitionend", () => this.syncFloatingWidgets());
        window.addEventListener("resize", () => this.scheduleFloatingSync());
        window.addEventListener("scroll", () => this.scheduleFloatingSync(), { passive: true });
        [1000, 2500, 5000].forEach((t) => setTimeout(() => this.syncFloatingWidgets(), t));

        this.domNodes.select.addEventListener("change", (e) => {
          const { target } = e;
          const variantPicker = this.mainProduct.querySelector('variant-picker');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
          this.currentVariant ? this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut) : this.toggleAddButton(true, window.MinimogStrings.unavailable);

          const selectedOption = target.options[target.selectedIndex];
          const selectedOptionIds = selectedOption.dataset.options.split(',').filter(id => id);

          if (variantPicker) {
            selectedOptionIds.forEach((optionId) => {
              const input = variantPicker.querySelector(`[data-option-value-id="${optionId}"]`);
              const { tagName } = input;
              switch (tagName) {
                case "OPTION":
                  const inputParent = input.parentNode; // select tag
                  inputParent.value = input.value;
                  break;
                case "INPUT":
                  input.checked = true;
                  break;
              }
            });
            variantPicker.dispatchEvent(new Event("change"));
          }
        });
      }

      /* =================================================================
       * GATORHATS - 26/08/2026
       * Xep cac phan tu noi o goc phai duoi khi sticky bar hien ra.
       *
       * Thu tu tu duoi len:
       *     [ sticky bar ]
       *        16px
       *     [ bubble chat ]
       *        12px
       *     [ nut scroll-to-top ]   (canh phai thang voi bubble chat)
       *
       * Khong hardcode con so, khong bam vao bien noi bo cua app chat.
       * Cach lam: DO vi tri that cua tung phan tu roi dat no vao dung cho.
       *
       * LUU Y: phai khoa `transition` truoc khi do. Neu phan tu dang chay
       * animation thi getBoundingClientRect() tra ve vi tri GIUA CHUNG,
       * vong lap se cong don qua da va nem no bay len tan tren.
       * Da dinh loi nay mot lan - dung go dong setProperty("transition").
       *
       * Bar an di -> tra tat ca ve dung cho cu.
       * ================================================================= */
      scheduleFloatingSync() {
        clearTimeout(this._floatSyncTimer);
        this.syncFloatingWidgets();
        this._floatSyncTimer = setTimeout(() => this.syncFloatingWidgets(), 500);
      }

      _visualOf(host) {
        // Shopify Inbox nam trong shadow DOM va host cua no phu kin man hinh,
        // nen phai lay dung phan tu nhin thay ben trong moi do duoc.
        try {
          if (host.shadowRoot) {
            return host.shadowRoot.querySelector(".activator-nudge, .activator, button") || host;
          }
        } catch (e) {}
        return host;
      }

      _numOr(value, fallback) {
        const n = parseFloat(value);
        return isNaN(n) ? fallback : n;
      }

      /**
       * Dat phan tu sao cho day duoi cua no nam o toa do desiredBottomY,
       * va (neu co) canh phai cach mep phai man hinh dung desiredRightGap px.
       */
      _place(host, desiredBottomY, desiredRightGap) {
        const visual = this._visualOf(host);

        // Khoa animation truoc khi do - xem ghi chu o tren
        host.style.setProperty("transition", "none", "important");

        let rect = visual.getBoundingClientRect();
        if (!rect.height) return null;

        const cs = getComputedStyle(host);
        let bottomOffset = this._numOr(host.dataset.ghBottom, this._numOr(cs.bottom, 0));
        let rightOffset = this._numOr(host.dataset.ghRight, this._numOr(cs.right, 0));

        for (let i = 0; i < 4; i++) {
          let settled = true;

          const dBottom = rect.bottom - desiredBottomY;
          if (Math.abs(dBottom) > 1) {
            bottomOffset = Math.max(0, bottomOffset + dBottom);
            host.style.setProperty("bottom", Math.round(bottomOffset) + "px", "important");
            host.dataset.ghBottom = String(Math.round(bottomOffset));
            settled = false;
          }

          if (typeof desiredRightGap === "number") {
            const dRight = window.innerWidth - rect.right - desiredRightGap;
            if (Math.abs(dRight) > 1) {
              rightOffset = Math.max(0, rightOffset - dRight);
              host.style.setProperty("right", Math.round(rightOffset) + "px", "important");
              host.dataset.ghRight = String(Math.round(rightOffset));
              settled = false;
            }
          }

          if (settled) break;
          rect = visual.getBoundingClientRect();
        }

        return rect;
      }

      _resetPlacement(host) {
        if (!host) return;
        if (host.dataset.ghBottom !== undefined || host.dataset.ghRight !== undefined) {
          host.style.removeProperty("bottom");
          host.style.removeProperty("right");
          host.style.removeProperty("transition");
          delete host.dataset.ghBottom;
          delete host.dataset.ghRight;
        }
      }

      syncFloatingWidgets() {
        const GAP_BAR = 16; // ho giua sticky bar va bubble chat
        const GAP_BTN = 12; // ho giua bubble chat va nut scroll-to-top
        if (!this.container) return;

        // Bar co dang thuc su nhin thay khong?
        // - an bang display:none     -> height = 0
        // - day xuong bang transform -> top >= innerHeight
        const barRect = this.container.getBoundingClientRect();
        const barVisible = barRect.height > 0 && barRect.top < window.innerHeight - 1;

        const chatHost = document.querySelector(
          "shopify-chat, #shopify-chat, .zsiq_floatmain, #tidio-chat, #chat-widget-container, #crisp-chatbox"
        );
        const topBtn = document.querySelector("#scroll-to-top-button");

        if (!barVisible) {
          this._resetPlacement(chatHost);
          this._resetPlacement(topBtn);
          return;
        }

        // 1. Bubble chat: ngay tren sticky bar
        let chatRect = null;
        if (chatHost) {
          chatRect = this._place(chatHost, barRect.top - GAP_BAR);
        }

        // 2. Nut scroll-to-top: ngay tren bubble chat, canh phai thang hang
        if (topBtn) {
          const probe = topBtn.getBoundingClientRect();
          if (!probe.height) {
            this._resetPlacement(topBtn);
          } else if (chatRect) {
            const rightGap = Math.round(window.innerWidth - chatRect.right);
            this._place(topBtn, chatRect.top - GAP_BTN, rightGap >= 0 && rightGap < 60 ? rightGap : undefined);
          } else {
            this._place(topBtn, barRect.top - GAP_BAR);
          }
        }
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      setUnavailable() {
        const productForm = this.querySelector('.m-product-form');
        const addButton = productForm.querySelector('[name="add"]');

        if (addButton) {
          this.toggleAddButton(true, window.MinimogStrings.unavailable);
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.m-product-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.innerHTML = window.MinimogStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      handleDisableSelectedVariantDefault() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        const pickerFields = this.querySelector('.m-product-option--dropdown-select');

        pickerFields.value = '';
        this.setUnavailable();
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
        this.scheduleFloatingSync();
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
          const isMainProduct = e.data.sectionId === this.mainProduct.dataset.sectionId;
          if (!isMainProduct) return;
          this.currentVariant = e.data.variant;
          if (this.currentVariant) {
            variantInput.value = e.data.variant.id;
            this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut)
          } else {
            variantInput.value = '';
            this.toggleAddButton(true, window.MinimogStrings.unavailable)
          }
        });
      }

      /* -----------------------------------------------------------------
       * GATORHATS FIX - 26/08/2026
       *
       * VAN DE:
       * Options cua PDP (Embroidery Style, Custom Text Style, Thread Color...)
       * do app Globo Product Options render, class tien to .gpo-*
       * KHONG phai custom field cua theme (.m-product-custom-field).
       * Nen dieu kien goc `if (!this.hasCustomFields) return;` luon dung
       * => toan bo co che bao ve khong bao gio chay
       * => sticky form tu submit id + quantity, tao line item khong co
       *    thong tin theu va khong thu phi add-on.
       *
       * CACH XU LY:
       * Sticky button khong tu submit nua. No uy quyen 100% cho nut
       * Add to Cart CHINH - noi Globo validate day du.
       *   - Dien du option  -> vao gio binh thuong, du property + phi add-on
       *   - Chua dien du    -> Globo chan, va ta cuon khach ve dung o dang thieu
       * Cach nay doc lap voi app options dang dung, doi app khac van chay.
       * ----------------------------------------------------------------- */
      handleCustomFields() {
        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        // Tim o option dau tien dang bao loi va cuon toi do
        const scrollToFirstError = () => {
          const err = document.querySelector(
            ".m-main-product--info .gpo-app .help-block.error, .m-main-product--info .m-product-custom-field .error"
          );
          if (!err || err.offsetParent === null) return false;

          const target =
            err.closest(".gpo-element, .gpo-form__group, .m-product-custom-field") || err;

          if (typeof __scrollToTop === "function") {
            __scrollToTop(target, () => {});
          } else if (target.scrollIntoView) {
            target.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          return true;
        };

        const delegateToMainForm = (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!this.mainAddToCart) return;

          this.mainAddToCart.click();

          // Cho app options ve xong thong bao loi roi moi quyet dinh co can cuon khong
          setTimeout(scrollToFirstError, 250);
        };

        if (addToCart) {
          addToCart.addEventListener("click", delegateToMainForm, true);
        }

        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (this.mainDynamicCheckout) this.mainDynamicCheckout.click();
              setTimeout(scrollToFirstError, 250);
            },
            true
          );
        }

        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.mainAddToCart.click();
            setTimeout(scrollToFirstError, 250);
          });
        }
      }
    }
  );
}
